/**
 * Offboarding classifiers stored on portal_employees (TASK-403). Stable keys;
 * display labels live in i18n (t.portal.profile.turnoverImpactLevels and
 * t.portal.profile.leavingReasons).
 */
export const TURNOVER_IMPACTS = ['regrettable', 'not_regrettable', 'cannot_assess'] as const

export type TurnoverImpact = (typeof TURNOVER_IMPACTS)[number]

export const isTurnoverImpact = (value: unknown): value is TurnoverImpact =>
    typeof value === 'string' && (TURNOVER_IMPACTS as readonly string[]).includes(value)

export const LEAVING_REASONS = [
    'own_wish',
    'extraordinary_termination',
    'redundancy',
    'fixed_term_end',
    'other',
] as const

export type LeavingReason = (typeof LEAVING_REASONS)[number]

export const isLeavingReason = (value: unknown): value is LeavingReason =>
    typeof value === 'string' && (LEAVING_REASONS as readonly string[]).includes(value)
